
import React, {useEffect, useState} from 'react';
import styles from './_category-switcher-drawer.module.scss';
import Drawer, { DrawerProps } from "@mui/material/Drawer";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import { ListItemButton, TextField } from '@mui/material';
import { isEmpty, includes } from 'ramda';
import { IPerformanceCategory } from '../../../Models/PerformanceCategory';
import TabCompleteIcon from '@mui/icons-material/CheckCircle';
import TabNotCompleteIcon from '@mui/icons-material/PanoramaFishEye'

export interface CategorySwitcherDrawerProps {
  onClose: () => void;
  onSelectCategory: (category: IPerformanceCategory) => void;
  isOpen: boolean;
  categories: IPerformanceCategory[];
  completedCategories: string[];
}
export default function CategorySwitcherDrawer (props:  CategorySwitcherDrawerProps) {
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [filteredCategories, setFilteredCategories] = useState<IPerformanceCategory[]>(props.categories);
  const checkedCategories = props.completedCategories;
  useEffect(() => {
    if(isEmpty(searchTerm)){
      setFilteredCategories(props.categories)
    } else {
      setFilteredCategories(props.categories.filter(c => includes(searchTerm!.toLowerCase(), c.name.toLowerCase())));
    }
  }, [searchTerm, props.categories]);
  return (
      <Drawer anchor={"left"} open={props.isOpen}
        onClose={() => {
          props.onClose();
        }}
      >
        <TextField
          label="Search"
          placeholder="search..."
          fullWidth
          margin="none"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          InputLabelProps={{
            shrink: true,
          }}
          variant="filled"
        />
        <List style={{maxHeight: 'calc(100vh - 90px)', overflowY: 'auto'}}>
        {filteredCategories.map((category, key) => (
            <ListItemButton 
              onClick={() => props.onSelectCategory(category)}
              key={key}>
              <ListItemIcon>{checkedCategories.find(c => c == category.id) ? <TabCompleteIcon style={{ color: 'green'}} /> : <TabNotCompleteIcon style={{ color: 'black'}} />}</ListItemIcon>
              <ListItemText primary={category.description} />
            </ListItemButton>
          ))}
        </List>
        <Divider />
        <Button onClick={() => props.onClose()}>Close</Button>
      </Drawer>
  );
}
